import CartRequest from '@/shared/infrastructure/cart/Request'

const actions = {
  addItemToCart({ rootState, dispatch }, product) {
    if (rootState.auth.isUserLoggedIn) {
      return dispatch('checkProductInUserCart', product)
    } else {
      return dispatch('checkProductInGuestCart', product)
    }
  },
  updateGuestCartItemQuantity({ commit }, payload) {
    commit('updateGuestCartItemQuantity', payload)
  },
  removeItemFromGuestCart({ commit }, index) {
    commit('removeItemFromGuestCart', index)
  },
  resetGuestCart({ commit }) {
    commit('resetGuestCart')
  },
  async fetchUserCart({ commit }) {
    const userCart = await CartRequest.fetchUserCart()
    commit('setUserCart', userCart)
  },
  updateUserCartItem(action, item) {
    return CartRequest.updateUserCartItem(item)
  },
  async updateUserCartItemQuantity({ dispatch, commit }, payload) {
    const item = {
      index: payload.index,
      cartId: payload.product.cartId,
      quantity: payload.quantity,
      inco_terms: payload.product.inco_terms
    }
    const result = await dispatch('updateUserCartItem', item)
    if (result) {
      commit('updateUserCartItemQuantity', item)
    }
  },
  async addItemToUserCart({ commit }, item) {
    const data = await CartRequest.addItemToUserCart(item)
    commit('addItemToUserCart', data)
  },
  resetUserCart({ commit }) {
    commit('resetUserCart')
  },
  async removeItemFromUserCart({ commit }, payload) {
    const result = await CartRequest.removeItemFromUserCart(payload.item)
    if (result) {
      commit('removeItemFromUserCart', payload.index)
    }
  },
  checkProductInUserCart({ dispatch, state }, product) {
    const cart = [...state.userCart]
    const existingItem = cart.find(item => {
      return (item.productId === product.id) && (item.inco_terms === product.inco_terms)
    })
    if (existingItem) {
      existingItem.quantity = parseInt(existingItem.quantity) + parseInt(product.quantity)
      dispatch('updateUserCartItem', existingItem)
      return 'Updated'
    } else {
      dispatch('addItemToUserCart', product)
      return 'Added'
    }
  },
  checkProductInGuestCart({ state,commit }, product) {
    const existingIndex = state.guestCart.findIndex(item => {
      return (item.id === product.id) && (item.inco_terms === product.inco_terms)
    })
    if (existingIndex > -1) {
      const quantity = state.guestCart[existingIndex].quantity + product.quantity
      commit('updateGuestCartItemQuantity', {index: existingIndex, quantity})
      return 'Updated'
    } else {
      commit('addItemToGuestCart', product)
      return 'Added'
    }
  },
  resetCart({ dispatch }) {
    dispatch('resetUserCart')
    dispatch('resetGuestCart')
  }
}

export default actions
